import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [ButtonModule, RippleModule, RouterLink],
  templateUrl: './notfound.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotfoundComponent {}
